
import { ISignInHpId } from "../../models/dto/generalApi/ISignInHpId";
import * as ApiWithToken from "../callApiWithToken";
import * as Api from "../callApi";


const isMobile: Boolean = false;

const userService = {
    getModuleByRole: async function (roleId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `Users/getModuleByRole?roleId=${roleId}&isMobile=${isMobile}`);
    },
    login: async function(signInHpId:ISignInHpId){
        return Api.postApi(process.env.REACT_APP_GENERAL_API + 'Users/signInHpId', signInHpId);
    },
    getPublisherById:async function(){
        return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `Users/getPublisherByUser`);
    },
    approvalTermsAndConditions:async function(email: string){
        return Api.postApi(process.env.REACT_APP_GENERAL_API + `Users/ApprovalTermsAndCondition`, {email});
    },
    checkInVsAbsence:async function(year: number, month: number){
        return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `Users/getCheckInVsAbsence?month=${month}&year=${year}`);
    },
    checkInVsAbsenceSummary:async function(year: number, month: number){
        return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `Users/getCheckInVsAbsenceSummary?month=${month}&year=${year}`);
  },
    checkInVsAbsenceExcel:async function(year: number, month: number, languageId: number){
        return ApiWithToken.getApiBlob(process.env.REACT_APP_GENERAL_API + `Users/getCheckInVsAbsenceExcel?month=${month}&year=${year}&languageId=${languageId}`);
  },
    checkInVsAbsenceSummaryExcel:async function(year: number, month: number, languageId: number){
        return ApiWithToken.getApiBlob(process.env.REACT_APP_GENERAL_API + `Users/getCheckInVsAbsenceSummaryExcel?month=${month}&year=${year}&languageId=${languageId}`);
    }
}
export default userService;
